import { Box, Container, Typography } from '@mui/material';
import { useThemeMode } from '../context/ThemeContext';

export default function TermsOfService() {
  const { colors } = useThemeMode();

  return (
    <Box sx={{ bgcolor: colors.bgDefault, minHeight: '100vh', py: 8 }}>
      <Container maxWidth="md">
        <Typography variant="h3" sx={{ color: colors.textPrimary, fontWeight: 700, mb: 3 }}>
          Conditions d'utilisation
        </Typography>

        <Typography variant="body1" sx={{ color: colors.textSecondary, mb: 3, lineHeight: 1.8 }}>
          Dernière mise à jour : juin 2026
        </Typography>

        <Typography variant="h5" sx={{ color: colors.textPrimary, fontWeight: 600, mb: 1.5, mt: 4 }}>
          1. Objet
        </Typography>
        <Typography variant="body1" sx={{ color: colors.textSecondary, mb: 2, lineHeight: 1.8 }}>
          Les présentes conditions régissent l'utilisation de la plateforme Publy Music.
          En créant un compte, vous acceptez ces conditions dans leur intégralité.
        </Typography>

        <Typography variant="h5" sx={{ color: colors.textPrimary, fontWeight: 600, mb: 1.5, mt: 4 }}>
          2. Description du service
        </Typography>
        <Typography variant="body1" sx={{ color: colors.textSecondary, mb: 2, lineHeight: 1.8 }}>
          Publy Music est une plateforme d'aide à la déclaration d'œuvres musicales
          auprès de la SACEM. Elle propose la génération de documents (feuillets SACEM, contrats),
          la signature électronique et le suivi des déclarations.
        </Typography>

        <Typography variant="h5" sx={{ color: colors.textPrimary, fontWeight: 600, mb: 1.5, mt: 4 }}>
          3. Responsabilité
        </Typography>
        <Typography variant="body1" sx={{ color: colors.textSecondary, mb: 2, lineHeight: 1.8 }}>
          Publy Music fournit un outil d'assistance. La responsabilité finale
          du contenu des déclarations incombe à l'utilisateur. Publy Music ne se
          substitue pas à un conseil juridique et ne garantit pas l'acceptation
          des documents par la SACEM.
        </Typography>

        <Typography variant="h5" sx={{ color: colors.textPrimary, fontWeight: 600, mb: 1.5, mt: 4 }}>
          4. Compte utilisateur
        </Typography>
        <Typography variant="body1" sx={{ color: colors.textSecondary, mb: 2, lineHeight: 1.8 }}>
          Vous êtes responsable de la confidentialité de vos identifiants. Toute activité
          réalisée depuis votre compte est réputée effectuée par vous. En cas de suspicion
          d'utilisation frauduleuse, contactez-nous immédiatement.
        </Typography>

        <Typography variant="h5" sx={{ color: colors.textPrimary, fontWeight: 600, mb: 1.5, mt: 4 }}>
          5. Propriété intellectuelle
        </Typography>
        <Typography variant="body1" sx={{ color: colors.textSecondary, mb: 2, lineHeight: 1.8 }}>
          Le contenu de la plateforme (interface, textes, code) est la propriété de
          Publy Music. Les œuvres déclarées via la plateforme restent intégralement
          la propriété de leurs auteurs.
        </Typography>
      </Container>
    </Box>
  );
}
